import {Component} from 'react';
import {connect} from 'react-redux';
import "./_App.scss";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import Amplify, {Auth} from 'aws-amplify';
import * as actions from './store/actions/index';
import {Routes} from './routes';
//import * as immersion_LoginComponent from './components/pages/auth/immersion/login';
import {LoginComponent} from './components/pages/auth/immersion/login';
import {RegisterComponent} from './components/pages/auth/immersion/register';
import {BeginComponent} from './components/pages/auth/immersion/begin';
import {BillingSuccessComponent} from './components/pages/auth/immersion/billing_success_2';
import {ConfirmEmailComponent} from './components/pages/auth/immersion/confirmEmail';
import {CreatePasswordComponent} from './components/pages/auth/immersion/createPassword';
import {ForgotPasswordComponent} from "./components/pages/auth/immersion/forgotPassword";
import {ResetPasswordComponent} from "./components/pages/auth/immersion/resetPassword";
import Deeplink from './components/pages/auth/immersion/deepLink';
import AccountVerification from './components/pages/auth/immersion/accountVerification';

import {KnownLoginComponent} from './components/pages/auth/known/login';
import {KnownRegisterComponent} from './components/pages/auth/known/register';
import {KnownBeginComponent} from './components/pages/auth/known/begin';
import {KnownBillingSuccessComponent} from './components/pages/auth/known/billing_success_2';
import {KnownConfirmEmailComponent} from './components/pages/auth/known/confirmEmail';
import {KnownCreatePasswordComponent} from './components/pages/auth/known/createPassword';
import {KnownForgotPasswordComponent} from "./components/pages/auth/known/forgotPassword";
import {KnownResetPasswordComponent} from "./components/pages/auth/known/resetPassword";
import KnownDeeplink from './components/pages/auth/known/deepLink';
import KnownAccountVerification from './components/pages/auth/known/accountVerification';

import {LivelyLoginComponent} from './components/pages/auth/lively/login';
import {LivelyRegisterComponent} from './components/pages/auth/lively/register';
import {LivelyBeginComponent} from './components/pages/auth/lively/begin';
import {LivelyBillingSuccessComponent} from './components/pages/auth/lively/billing_success_2';
import {LivelyConfirmEmailComponent} from './components/pages/auth/lively/confirmEmail';
import {LivelyCreatePasswordComponent} from './components/pages/auth/lively/createPassword';
import {LivelyForgotPasswordComponent} from "./components/pages/auth/lively/forgotPassword";
import {LivelyResetPasswordComponent} from "./components/pages/auth/lively/resetPassword";
import LivelyDeeplink from './components/pages/auth/lively/deepLink';
import LivelyAccountVerification from './components/pages/auth/lively/accountVerification';

import {WondrLoginComponent} from './components/pages/auth/wondr/login';
import {WondrRegisterComponent} from './components/pages/auth/wondr/register';
import {WondrBeginComponent} from './components/pages/auth/wondr/begin';
import {WondrBillingSuccessComponent} from './components/pages/auth/wondr/billing_success_2';
import {WondrConfirmEmailComponent} from './components/pages/auth/wondr/confirmEmail';
import {WondrCreatePasswordComponent} from './components/pages/auth/wondr/createPassword';
import {WondrForgotPasswordComponent} from "./components/pages/auth/wondr/forgotPassword";
import {WondrResetPasswordComponent} from "./components/pages/auth/wondr/resetPassword";
import WondrDeeplink from './components/pages/auth/wondr/deepLink';
import WondrAccountVerification from './components/pages/auth/wondr/accountVerification';

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import {ThemeProvider} from '@material-ui/core';
import {themeConfigs} from './config/theme';
import NotFound from './components/pages/auth/notFound';
import Config from "./config/config";
import {apiClient} from "./config/apiClient";
import BleWidgetComponent from './components/atoms/blewidget'
import UserVerify from './components/atoms/userVerify';
import ErrorBoundary from './ErrorBoundary';
import {LoginWithEmailComponent} from "./components/pages/auth/immersion/loginWithEmail";

const publicIp = require('public-ip');

let masterRoutes = {
  login: LoginComponent,
  loginWithEmail: LoginWithEmailComponent,
  register: RegisterComponent,
  begin: BeginComponent,
  success: BillingSuccessComponent,
  confirm: ConfirmEmailComponent,
  password: CreatePasswordComponent,
  forgot: ForgotPasswordComponent,
  reset: ResetPasswordComponent,
  deep: Deeplink,
  verify: AccountVerification
};

if (Config.DEFAULT_SUBBRAND == 'known') {
  masterRoutes = {
    login: KnownLoginComponent,
    loginWithEmail: LoginWithEmailComponent,
    register: KnownRegisterComponent,
    begin: KnownBeginComponent,
    success: KnownBillingSuccessComponent,
    confirm: KnownConfirmEmailComponent,
    password: KnownCreatePasswordComponent,
    forgot: KnownForgotPasswordComponent,
    reset: KnownResetPasswordComponent,
    deep: KnownDeeplink,
    verify: KnownAccountVerification
  };
}

if (Config.DEFAULT_SUBBRAND == 'lively') {
  masterRoutes = {
    login: LivelyLoginComponent,
    loginWithEmail: LoginWithEmailComponent,
    register: LivelyRegisterComponent,
    begin: LivelyBeginComponent,
    success: LivelyBillingSuccessComponent,
    confirm: LivelyConfirmEmailComponent,
    password: LivelyCreatePasswordComponent,
    forgot: LivelyForgotPasswordComponent,
    reset: LivelyResetPasswordComponent,
    deep: LivelyDeeplink,
    verify: LivelyAccountVerification
  };
}

if (Config.DEFAULT_SUBBRAND == 'wondr') {
  masterRoutes = {
    login: WondrLoginComponent,
    loginWithEmail: LoginWithEmailComponent,
    register: WondrRegisterComponent,
    begin: WondrBeginComponent,
    success: WondrBillingSuccessComponent,
    confirm: WondrConfirmEmailComponent,
    password: WondrCreatePasswordComponent,
    forgot: WondrForgotPasswordComponent,
    reset: WondrResetPasswordComponent,
    deep: WondrDeeplink,
    verify: WondrAccountVerification
  };
}


// cognito amplify settings
Amplify.configure({
  Auth: {
    identityPoolId: Config.CONFIG.IDENTITY_POOL_ID,
    region: Config.CONFIG.REGION,
    userPoolId: Config.CONFIG.USER_POOL,
    userPoolWebClientId: Config.CONFIG.CLIENT_ID,
    oauth: {
      domain: Config.APP_DOMAIN,
      redirectSignIn: Config.APP_REDIRECT_SIGN_IN,
      redirectSignOut: Config.APP_REDIRECT_SIGN_OUT,
      responseType: Config.APP_RESPONSE_TYPE
    }
  },
  Storage: {
    region: Config.CONFIG.REGION,
    bucket: Config.APP_S3_BUCKET,
    identityPoolId: Config.CONFIG.IDENTITY_POOL_ID
  },
})

interface IProps {
  onAuthCheckState: (history: History) => void;
  gotGoogleUserProfile: (pictureURL: string) => void;
  history: History;
  auth: any;
  loginUser: any;
}

interface IState {
  userLogin: boolean;
  overview: boolean;
}

interface Heap {
  track: (event: string, properties?: any) => void;
  identify: (identity: string) => void;
  resetIdentity: () => void;
  addUserProperties: (properties: any) => void;
  addEventProperties: (properties: any) => void;
  removeEventProperty: (property: string) => void;
  clearEventProperties: () => void;
  appid: string;
  userId: string;
  identity: string | null;
  config: any;
}

declare const heap: Heap;

let _isMounted = false;
class App extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    _isMounted = false;
    this.state = {
      userLogin:false,
      overview: false
    };
    window.addEventListener('storage', e => {
      if (e.key === 'user_data' && e.oldValue && !e.newValue) {
        window.location.reload();
      }
      if (e.key === 'loggedIn' && e.oldValue === null && e.newValue && window && window.location && window.location.pathname != "/user/confirm-email") {
        window.location.reload();
      }
    })
  }

  // load init actions
  componentDidMount() {
    const queryStringRsc = new URLSearchParams(window.location.search).get("rsc");
    const queryStringOverview = new URLSearchParams(window.location.search).get("overview");
    if (queryStringRsc && queryStringRsc !== "") {
      localStorage.setItem("rscString",queryStringRsc)
    }
    const session_code = new URLSearchParams(window.location.search).get("session_code");
    if (session_code && session_code !== "") {
      localStorage.setItem("session_code", session_code)
    }
    if (queryStringOverview && queryStringOverview !== "" && !localStorage.getItem("user_data")) {
      this.setState({
        overview: true
      });
      localStorage.setItem("overviewRedirect", window.location.pathname)
    }
    // Call this whenever information about your visitors becomes available
    // Please use Strings, Numbers, or Bools for value types.
    _isMounted = true;
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};
    if (loginUserData.username) {
      if (Config.ENV === 'prod') {
        heap.identify(loginUserData.user_id);
        heap.addUserProperties({
          'Email': loginUserData.username,
          'Full Name': loginUserData.first_name + " " + loginUserData.last_name,
          'Role': loginUserData.role_description,
          'Plan': loginUserData.role_alias,
          'Team': loginUserData.department_name,
          'UserType': loginUserData.role_name
        });
      }
    }
    this.props.onAuthCheckState(this.props.history);
    if (loginUserData && loginUserData.user_id) {
      _isMounted && this.mqttPreProcess();
      this.setState({
        userLogin:true
      })
    }
    this.setIpAddress();

    Auth.currentAuthenticatedUser()
      .then((userData: any) => {
        if (userData.username.startsWith('google')) { // google signed in user
          const attributes = userData.attributes;
          if (attributes && attributes.picture) {
            this.props.gotGoogleUserProfile(attributes.picture);
          }
        }
      })
  }

  async setIpAddress() {
    try {
      const ipAddress = await publicIp.v4()
      if (ipAddress) {
        localStorage.setItem("ipAddress", ipAddress)
      }
    } catch (e) {

    }
  }

  componentWillUnmount(){
    _isMounted = false;
  }

  async mqttPreProcess() {
    let credentials = null;
    try {
      credentials = await Auth.currentUserCredentials();
    } catch (e) {
      localStorage.clear();
      window.location.replace('/user/login');
      
    }
    if (credentials) {
      if (credentials.authenticated) {
        const identityId = credentials.identityId;
        await this.attachPolicy(identityId);
      } else {
        localStorage.clear();
        window.location.replace('/user/login');
      }
    }
  }

  async attachPolicy(identityId: string) {
    await apiClient(true).post('/security/v2/security/policy', {identity_id: identityId});
  }

  render() {
    const is_loaded = this.props.auth.is_loaded;

    return (
      <ThemeProvider theme={themeConfigs}>
        {(this.props.auth.isUserverification === true) && 
          <UserVerify />
        }
        <ToastContainer />
        <ReactNotification />
        <BrowserRouter>
          {is_loaded ? (
            <>
              <Switch>
                <Route exact path="/404" render={() => <NotFound loginUser={this.props.loginUser} />}/>
                <Route exact path="/user/login" component={masterRoutes.login} />
                <Route exact path="/user/login/email-password" component={masterRoutes.loginWithEmail} />
                <Route exact path="/user/register" component={masterRoutes.register} />
                <Route exact path="/user/begin/:plan" component={masterRoutes.begin} />
                <Route exact path="/user/success" component={masterRoutes.success} />
                <Route exact path="/user/forgot-password" component={masterRoutes.forgot} />
                <Route exact path="/user/reset-password" component={masterRoutes.reset} />
                <Route exact path="/user/confirm-email" component={masterRoutes.confirm} />
                <Route exact path="/user/create-password" component={masterRoutes.password} />
                <Route exact path="/user/account-verification" component={masterRoutes.verify} />
                <Route exact path="/deeplink" component={masterRoutes.deep} />
                {!this.state.userLogin && <Redirect to='/404' />}
              </Switch>
              <ErrorBoundary>
                <Routes />
              </ErrorBoundary>
              <BleWidgetComponent/>
            </>
          ) : (
            <div></div>
          )}
        </BrowserRouter>
      </ThemeProvider>
    )
  }
}

// load reducers
const mapStateToProps = (state: any) => {
  const { user: loginUser } = state.authUser;

  return {
    auth: state.authUser,
    loginUser
  };
};

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    onAuthCheckState: (history: any) => {
      dispatch(actions.onAuthCheckState(history))
    },
    gotGoogleUserProfile: (pictureURL: string) => {
      dispatch(actions.gotGoogleUserProfile(pictureURL))
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
// export component 
